<template>
    <div id="hqAssignBox">        
        <div class="searchWrap">
            <div class="row1">
                <div class="itemWrap">
                    <label>關鍵字: </label>
                    <el-input v-model="keyword" placeholder="關鍵字" style="width:50%;margin: 0px 15px;" clearable></el-input>                    
                    <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                </div>
            </div>          
            <div class="row3"  >                
                <div class="itemWrap" >
                    <el-button type="danger" icon="el-icon-plus" @click="addSaveSearch">新增搜尋條件</el-button>          
                </div>                
            </div>               
        </div>
        <div class="content" >
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @select="handleSelectionChange">                            
              <el-table-column label="搜尋名稱"  prop="ConditionName" min-width="10%">
              </el-table-column>                              
              <el-table-column label="搜尋語法" prop="ssWord"  min-width="40%">      
                <template slot-scope="scope">
                    <el-tag v-for="tag in scope.row.ssWord" :key="tag"  type="success"  :disable-transitions="false" style="margin-right:10px;" @close="handleClose(tag)">
                        {{tag}}
                    </el-tag>
                </template>          
              </el-table-column>              
              <el-table-column label="備註" prop="memo"  min-width="10%"> 
              </el-table-column>                                       
              <el-table-column label="企業資訊" min-width="10%">
                <template slot-scope="scope">
                    <el-button type="text" @click="editSaveSearch(scope.row)" icon="el-icon-edit">編輯</el-button>
                    <el-button type="text" @click="delSs(scope.row)" icon="el-icon-delete">刪除</el-button>   
                </template>
              </el-table-column>                                 
            </el-table>                
        </div>
        <div class="pageBox">
            <Pagination
                @currentChange="pageChange"
                :pageSize="this.listQuery.Page_Size"
                :propsCurrentPage="this.listQuery.Page_Num"
                :totalLists="totalLists">
            </Pagination>
        </div>   

        <el-dialog :title="diaglogTitle" :visible.sync="showSaveSearch" width="75%" center>
            <div class="dialogBox" >

                <div class="row1">
                    <div class="titleLabel">搜尋名稱：</div>
                    <div style="flex:1; margin: 10px 10px 10px 0;">
                        <el-input v-model="addInfo.ConditionName" placeholder="請輸入標籤名稱" maxlength="100" show-word-limit></el-input>
                    </div>
                </div>
                <div class="row1">
                    <div class="titleLabel">已選擇條件</div>
                    <div style="flex:1; display:flex; flex-wrap:wrap; align-items:center; margin: 5px 0;">
                        <el-tag v-for="tag in lstQuery" :key="tag" type="success" closable :disable-transitions="false" style="margin-right: 5px;" @close="handleClose(tag)">
                        {{tag}}
                        </el-tag>
                    </div>
                </div>
                <div class="row1">
                    <div class="titleLabel">預設地區</div>
                    <div class="itemWrap">
                        <DistSelection  v-model="selectedAreaValue"  width="200px;"  @area-change="handleAreaChange" />
                    </div>
                </div>
                <!--<div class="row1">
                    <div class="itemBox" style="width: 100%;">
                        <label>搜尋關鍵詞</label>
                        <el-input v-model="keyword" placeholder="公司名稱 / 統一編號 / 關鍵詞" style="width:50%;margin-right:15px;" clearable></el-input>                                      
                    </div>          
                </div> -->
                <div class="row1">                    
                    <div class="titleLabel">篩選條件</div>                                    
                    <div class="itemWrap">                                                        
                        <el-dropdown placement="bottom-start" @command="comStatusChangeHandler" trigger="click">
                            <span class="el-dropdown-link">
                                公司狀況<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="全部">全部</el-dropdown-item>
                                <el-dropdown-item command="營業中">營業中</el-dropdown-item>
                                <el-dropdown-item command="非營業中">非營業中</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="itemWrap">                    
                        <el-dropdown placement="bottom-start" @command="comTypeChangeHandler" trigger="click">
                            <span class="el-dropdown-link">
                                公司類別<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="全部">全部</el-dropdown-item>
                                <el-dropdown-item v-for="item in ComTypeList" :key="item.comType" :command="item.comType">
                                    {{ item.comType }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>                    
                    <div class="itemWrap">                    
                        <el-dropdown placement="bottom-start" @command="orgTypeChangeHandler" trigger="click">
                            <span class="el-dropdown-link">
                                組織別<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="全部">全部</el-dropdown-item>
                                <el-dropdown-item v-for="item in OrgTypeList" :key="item.comType" :command="item.comType">
                                    {{ item.comType }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>            
                    <div class="itemWrap">
                        <el-checkbox v-model="IsCustomer"  @change="otherChangeHandler('既有客戶')">
                            <label style="font-size: 13px;">既有客戶</label>
                        </el-checkbox>         
                    </div>         
                    <div class="itemWrap">
                        <el-checkbox v-model="IsInvoice"  @change="otherChangeHandler('有發票')">
                            <label style="font-size: 13px;">有發票</label>
                        </el-checkbox>         
                    </div>                          
                    <div class="itemWrap">
                        <el-checkbox v-model="IsImport"  @change="otherChangeHandler('有進口')">
                            <label style="font-size: 13px;">有進口</label>
                        </el-checkbox>         
                    </div>         
                    <div class="itemWrap">
                        <el-checkbox v-model="IsExport"  @change="otherChangeHandler('有出口')">
                            <label style="font-size: 13px;">有出口</label>
                        </el-checkbox>                  
                    </div>
                    <div class="itemWrap">
                        <el-checkbox v-model="IsFactory"  @change="otherChangeHandler('有工廠')">
                            <label style="font-size: 13px;">有工廠</label>
                        </el-checkbox>           
                    </div>
                </div>  
                <div class="row1">
                    <div class="titleLabel">進階條件</div>
                    <!-- 資本額 -->
                    <div class="itemWrap">
                        <el-dropdown placement="bottom-start" @command="radClick" trigger="click"> 
                            <span class="el-dropdown-link">
                                實收資本<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-money" v-for="c in capList" :command="c.value" :key="c.value" >
                                {{c.cap}}
                                </el-dropdown-item>
                                <el-dropdown-item icon="el-icon-edit" command="custom">
                                自訂區間
                                </el-dropdown-item>                                                
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    

                    <!-- 公司設立日期 -->
                    <div class="itemWrap">
                        <el-dropdown placement="bottom-start" @command="yearClick" trigger="click"> 
                        <span class="el-dropdown-link">
                            設立年數<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-date" v-for="c in yearList" :command="c.value" :key="c.value" >
                            {{c.cap}}
                            </el-dropdown-item>
                            <el-dropdown-item icon="el-icon-edit" command="custom">
                            自訂區間
                            </el-dropdown-item>                                                
                        </el-dropdown-menu>
                        </el-dropdown>
                    </div> 

                    <!-- 行業代號下拉選單 -->                
                    <div class="itemWrap">
                        <IndusCodeSelection size="small"
                            v-model="selectedIndustryCode"
                            @change="handleIndustryCodeChange"
                        /> 

                    </div>
                </div>                
                
                <div class="row1 memoRow">
                    <div class="titleLabel">備註</div>
                    <div style="flex:1; margin: 10px 10px 10px 0;">
                        <el-input type="textarea" rows="2" v-model="addInfo.memo" placeholder="簡明描述備註" clearable maxlength="100" show-word-limit></el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="saveSearchOp" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />{{ dialogButton}}</el-button>
                    <el-button type="danger"  @click="showSaveSearch=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>

        <el-dialog title="自訂資本額區間" :visible.sync="showCustomCapital" width="40%" center>
            <div class="dialogBox">
                <el-form label-width="100px">
                    <el-form-item label="起始金額">
                        <el-input v-model="customCapital.start" placeholder="請輸入起始金額（萬元）" type="number">
                            <template slot="append">萬元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="結束金額">
                        <el-input v-model="customCapital.end" placeholder="請輸入結束金額（萬元）" type="number">
                            <template slot="append">萬元</template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmCustomCapital"><font-awesome-icon icon="check" style="margin-right:5px;" />確定</el-button>
                <el-button type="danger" @click="showCustomCapital=false"><font-awesome-icon icon="times" style="margin-right:5px;" />取消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="自訂設立日期區間" :visible.sync="showCustomYear" width="40%" center>
            <div class="dialogBox">
                <el-form label-width="100px">
                    <el-form-item label="起始年限">
                        <el-input v-model="customYear.start" placeholder="請輸入起始年限（年）" type="number">
                            <template slot="append">年</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="結束年限">
                        <el-input v-model="customYear.end" placeholder="請輸入結束年限（年）" type="number">
                            <template slot="append">年</template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmCustomYear"><font-awesome-icon icon="check" style="margin-right:5px;" />確定</el-button>
                <el-button type="danger" @click="showCustomYear=false"><font-awesome-icon icon="times" style="margin-right:5px;" />取消</el-button>
            </span>
        </el-dialog>     

    </div>

    
</template>

<script>
import DistSelection from '../../components/DistSelection.vue';
import { notify, handleError } from '../../utils/notify';
import IndusCodeSelection from '@/components/IndusCodeSelection.vue'

export default {
    components: {IndusCodeSelection, DistSelection},
    data() {
        return {
            diaglogTitle: "新增搜尋條件",
            dialogButton: "新增",
            diaglogMode: "add", // add | edit
            tableData: [],

            showSaveSearch: false,
            

            totalLists:0,
            keyword: "",  

            listQuery: {
                searchContent:"",
                Page_Size:10,
                Page_Num:1
            },   

            // 原有的 lstQuery（顯示用）
            lstQuery: [],
            // 新增：結構化的查詢條件（用於 API 查詢）
            queryConditions: {
                keyword: '',           // 關鍵字
                companyStatus: '',     // 公司狀況
                companyType: [],       // 公司類別
                orgType: [],          // 組織別
                isCustomer: false,    // 既有客戶
                isInvoice: false,     // 有發票
                isImport: false,      // 有進口
                isExport: false,      // 有出口
                isFactory: false,     // 有工廠
                capital: {            // 資本額
                    start: '',
                    end: '',
                    range: ''         // 如 "0~100萬"
                },
                setupDate: {          // 設立日期
                    range: '',        // 如 "1-3年"
                    start: '',        // 計算後的開始日期，如 "2020-01-01"
                    end: '',          // 計算後的結束日期，如 "2022-12-31"
                    rangeValue: ''    // yearList 的 value
                },
                industryCode: [],     // 行業代碼
                location: {           // 地址
                    area: '',         // 區域：北部/中部/南部/東部
                    city: '',         // 縣市
                    district: ''      // 區域
                },
                geolocation: {        // 地理位置
                    Latitude: '',     // 緯度
                    Longitude: '',    // 經度
                    Distance: ''      // 距離，單位公里
                }                
            },    
            // 新增：查詢條件映射表（用於標籤與結構的對應）
            queryConditionMap: new Map(),      

            // 地區選擇相關（簡化後）
            selectedAreaValue: ['全部', '全部'],
            selectedCity: '全部',

            // 組織別相關
            OrgTypeList: [
                { comType: "股份有限公司" },
                { comType: "有限公司" },
                { comType: "獨資" },
                { comType: "合夥" },
                { comType: "其他" }
            ],
            ComTypeList: [
                { comType: "上市" },
                { comType: "上櫃" },
                { comType: "興櫃" },
                { comType: "公開發行" }
            ],         
            capList: [
                { cap: "2000萬(含)以下", value: 1, start: 0, end: 2000 },
                { cap: "2001萬~3000萬(含)以下", value: 2, start: 2001, end: 3000 },
                { cap: "3001萬~8000萬(含)以下", value: 3, start: 3001, end: 8000 },
                { cap: "8001萬~1億(含)以下", value: 4, start: 8001, end: 10000 },
                { cap: "1億(不含)以上", value: 5, start: 10001, end: 999999999 }        
            ],

            // 自訂資本額區間
            showCustomCapital: false,
            customCapital: {
                start: '',
                end: ''
            },

            yearList: [
                { cap: "未滿1年", start: 0, end: 1, value: 1 },
                { cap: "1年以上-未滿3年", start: 1, end: 3, value: 2 },
                { cap: "3年以上-未滿5年", start: 3, end: 5, value: 3 },
                { cap: "5年以上-未滿10年", start: 5, end: 10, value: 4 },
                { cap: "10年(含)以上", start: 10, end: 20, value: 5 }          
            ],

            industryCodeNameMap: {},

            // 自訂設立日期區間
            showCustomYear: false,
            customYear: {
                start: '',
                end: ''
            },

            // 其他篩選條件
            IsImport: false,
            IsExport: false,
            IsInvoice: false,
            IsCustomer: false,
            IsFactory: false,   
            
            selectedIndustryCode: [], // 單選：['A', '01', '011', '0111']            

            addInfo: {
                ID: '',
                ConditionName: '',
                memo: ''
            },

        }        

        
    },
    methods: {

        async loadIndustryCodeNameMap() {
            try {
                const response = await fetch('/indusCode.json');
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const json = await response.json();
                const map = {};

                const walk = (nodes = []) => {
                    nodes.forEach(node => {
                        if (node && node.value && node.label) {
                            map[node.value] = node.label;
                        }
                        if (node && Array.isArray(node.children) && node.children.length > 0) {
                            walk(node.children);
                        }
                    });
                };

                walk(json?.data || []);
                this.industryCodeNameMap = map;
            } catch (error) {
                console.error('載入行業代號名稱對照失敗:', error);
                this.industryCodeNameMap = {};
            }
        },

        formatIndustryCodeDisplay(value) {
            if (Array.isArray(value)) {
                return value.map(code => this.industryCodeNameMap[code] || code);
            }

            if (typeof value === 'string') {
                return this.industryCodeNameMap[value] || value;
            }

            return value || null;
        },

        async getBranchDist() {
            const { branchArea, branchCity, branchDist } = this.$store.state;
            console.log("父組件 - 從 Vuex 讀取的地區：", branchArea, branchCity, branchDist);
            
            // 只有當所有值都存在時才設置（避免 [null, null, null] 的情況）
            if (branchArea && branchCity) {
                if (branchDist) {
                    this.selectedAreaValue = [branchArea, branchCity, branchDist];
                } else {
                    this.selectedAreaValue = [branchArea, branchCity];
                }
                console.log("父組件 - 初始化選擇區域:", this.selectedAreaValue);
                
                // 等待子組件完成初始化
                await this.$nextTick();
                this.handleAreaChange(this.selectedAreaValue);
            }
        }   ,        

        normalizeLocationSelection(values = []) {
            const areaNames = ['北部', '中部', '南部', '東部'];
            const safeValues = Array.isArray(values) ? values.filter(Boolean) : [];

            let area = '';
            let city = '';
            let district = '';

            if (safeValues.length === 1) {
                const [first] = safeValues;
                if (areaNames.includes(first)) {
                    area = first;
                } else if (first !== '全部') {
                    city = first;
                }
            } else if (safeValues.length === 2) {
                const [first, second] = safeValues;
                if (areaNames.includes(first) || first === '全部') {
                    area = first !== '全部' ? first : '';
                    city = second !== '全部' ? second : '';
                } else {
                    city = first !== '全部' ? first : '';
                    district = second !== '全部' ? second : '';
                }
            } else if (safeValues.length >= 3) {
                area = safeValues[0] !== '全部' ? safeValues[0] : '';
                city = safeValues[1] !== '全部' ? safeValues[1] : '';
                district = safeValues[2] !== '全部' ? safeValues[2] : '';
            }

            return { area, city, district };
        },

        formatLocationDisplay(location = {}) {
            const area = location.area && location.area !== '全部' ? location.area : '';
            const city = location.city && location.city !== '全部' ? location.city : '';
            const district = location.district && location.district !== '全部' ? location.district : '';
            const cityDistrict = `${city}${district}`;
            return cityDistrict || area || null;
        },

        // 處理區域變更（從子組件接收事件）
        handleAreaChange(values) {
            console.log('父組件接收到區域變更（完整路徑）：', values);
            
            if (!values || values.length === 0) {
                this.selectedCity = "全部";
                this.selectedDistrict = "";
                
                return;
            }
            
            // 先移除之前的地點選擇標籤
            this.removePreviousLocationTags();

            const locationValue = this.normalizeLocationSelection(values);
            const displayText = this.formatLocationDisplay(locationValue);

            this.selectedCity = locationValue.city || '全部';
            this.selectedDistrict = locationValue.district || '';

            if (!displayText) {
                return;
            }

            this.listQuery.comLoc = displayText;
            this.addQueryCondition('location', locationValue, displayText);

            console.log('加入查詢條件的完整地址標籤：', displayText);

        },        
        // 移除之前的地點選擇標籤
        removePreviousLocationTags() {
            // 定義可能的地點相關標籤模式
            const locationPatterns = [
                // 區域名稱
                '北部', '中部', '南部', '東部',
                // 縣市名稱 (包含常見的縣市)
                '臺北市', '新北市', '桃園市', '臺中市', '臺南市', '高雄市',
                '新竹市', '新竹縣', '苗栗縣', '彰化縣', '南投縣', '雲林縣',
                '嘉義市', '嘉義縣', '屏東縣', '宜蘭縣', '花蓮縣', '臺東縣',
                '澎湖縣', '金門縣', '連江縣', '基隆市'
            ];
            
            // 移除符合地點模式的標籤
            this.lstQuery = this.lstQuery.filter(tag => {
                // 檢查是否為地點標籤
                const isLocationTag = locationPatterns.some(pattern => tag.includes(pattern)) ||
                                    // 檢查是否包含"市"、"縣"、"區"等地點相關字詞
                                    /.*[市縣區鄉鎮].*/.test(tag) ||
                                    // 檢查是否為組合地址（如"臺北市中山區"）
//                                     /.*市.*區/.test(tag);
                                    false;
                
                return !isLocationTag;
            });
            
            console.log('移除地點標籤後的 lstQuery：', this.lstQuery);
        },          

        // 新增查詢條件（同時更新 lstQuery 和 queryConditions）
        addQueryCondition(type, value, displayText) {
            // 1. 更新顯示標籤
            if (!this.lstQuery.includes(displayText)) {
                this.lstQuery.push(displayText);
            }
            
            // 2. 更新結構化資料
            switch(type) {
                case 'keyword':
                    this.queryConditions.keyword = value;
                    break;
                    
                case 'companyStatus':
                    this.queryConditions.companyStatus = value;
                    break;
                    
                case 'companyType':
                    if (!this.queryConditions.companyType.includes(value)) {
                        this.queryConditions.companyType.push(value);
                    }
                    break;
                    
                case 'orgType':
                    if (!this.queryConditions.orgType.includes(value)) {
                        this.queryConditions.orgType.push(value);
                    }
                    break;
                    
                case 'isCustomer':
                    this.queryConditions.isCustomer = value;
                    break;
                    
                case 'isInvoice':
                    this.queryConditions.isInvoice = value;
                    break;
                    
                case 'isImport':
                    this.queryConditions.isImport = value;
                    break;
                    
                case 'isExport':
                    this.queryConditions.isExport = value;
                    break;
                    
                case 'isFactory':
                    this.queryConditions.isFactory = value;
                    break;
                    
                case 'capital':
                    this.queryConditions.capital = value;
                    break;
                    
                case 'setupDate':
                    this.queryConditions.setupDate = value;
                    break;
                    
                case 'industryCode':
                    if (!this.queryConditions.industryCode.includes(value)) {
                        this.queryConditions.industryCode.push(value);
                    }
                    break;
                    
                case 'location':
                    this.queryConditions.location = value;
                    break;
            }
            
            // 3. 建立映射關係（標籤文字 -> 條件類型和值）
            this.queryConditionMap.set(displayText, { type, value });
            
            console.log('查詢條件已更新:', {
                displayTags: this.lstQuery,
                structuredData: this.queryConditions,
                mapping: Array.from(this.queryConditionMap.entries())
            });
        },
        
        // 移除查詢條件
        removeQueryCondition(displayText) {
            // 1. 從顯示標籤中移除
            const index = this.lstQuery.indexOf(displayText);
            if (index > -1) {
                this.lstQuery.splice(index, 1);
            }
            
            // 2. 從結構化資料中移除
            const mapping = this.queryConditionMap.get(displayText);
            if (mapping) {
                const { type, value } = mapping;
                
                switch(type) {
                    case 'keyword':
                        this.queryConditions.keyword = '';
                        this.keyword = '';
                        break;
                        
                    case 'companyStatus':
                        this.queryConditions.companyStatus = '';
                        this.selectedComStatus = '全部';
                        break;
                        
                    case 'companyType':
                        const ctIndex = this.queryConditions.companyType.indexOf(value);
                        if (ctIndex > -1) {
                            this.queryConditions.companyType.splice(ctIndex, 1);
                        }
                        break;
                        
                    case 'orgType':
                        const otIndex = this.queryConditions.orgType.indexOf(value);
                        if (otIndex > -1) {
                            this.queryConditions.orgType.splice(otIndex, 1);
                        }
                        break;
                        
                    case 'isCustomer':
                        this.queryConditions.isCustomer = false;
                        this.IsCustomer = false;
                        break;
                        
                    case 'isInvoice':
                        this.queryConditions.isInvoice = false;
                        this.IsInvoice = false;
                        break;
                        
                    case 'isImport':
                        this.queryConditions.isImport = false;
                        this.IsImport = false;
                        break;
                        
                    case 'isExport':
                        this.queryConditions.isExport = false;
                        this.IsExport = false;
                        break;
                        
                    case 'isFactory':
                        this.queryConditions.isFactory = false;
                        this.IsFactory = false;
                        break;
                        
                    case 'capital':
                        this.queryConditions.capital = { start: '', end: '', range: '' };
                        this.TotCapStart = '';
                        this.TotCapEnd = '';
                        this.radCap = '';
                        break;
                        
                    case 'setupDate':
                        this.queryConditions.setupDate = { range: '', start: '', end: '', rangeValue: '' };
                        this.yearCap = '';
                        break;
                        
                    case 'industryCode':
                        const icIndex = this.queryConditions.industryCode.indexOf(value);
                        if (icIndex > -1) {
                            this.queryConditions.industryCode.splice(icIndex, 1);
                        }
                        break;
                        
                    case 'location':
                        this.queryConditions.location = { area: '', city: '', district: '' };
                        this.selectedCity = '全部';
                        this.selectedDistrict = '';
                        break;
                }
                
                // 3. 從映射表中移除
                this.queryConditionMap.delete(displayText);
            }
        },
        
        // 清空所有查詢條件
        clearAllQueryConditions() {
            // 清空顯示標籤
            this.lstQuery = [];
            
            // 清空結構化資料
            this.queryConditions = {
                keyword: '',
                companyStatus: '',
                companyType: [],
                orgType: [],
                isCustomer: false,
                isInvoice: false,
                isImport: false,
                isExport: false,
                isFactory: false,
                capital: { start: '', end: '', range: '' },
                setupDate: { range: '', start: '', end: '', rangeValue: '' },
                industryCode: [],
                location: { area: '', city: '', district: '' },
                geolocation: { Latitude: '', Longitude: '', Distance: '' }
            };
            
            // 清空映射表
            this.queryConditionMap.clear();
            
            // 清空 UI 狀態
            this.keyword = '';
            this.IsCustomer = false;
            this.IsInvoice = false;
            this.IsImport = false;
            this.IsExport = false;
            this.IsFactory = false;
            this.selectedIndustryCode = [];
            this.selectedAreaValue = ['全部', '全部'];
            this.selectedCity = '全部';
            this.selectedDistrict = '';
            this.showCustomCapital = false;
            this.customCapital = {
                start: '',
                end: ''
            };
            this.showCustomYear = false;
            this.customYear = {
                start: '',
                end: ''
            };
            this.radCap = '';
            this.yearCap = '';
        },
        
        // 從 queryConditions 重建 lstQuery 和映射關係（用於編輯模式）
        rebuildFromQueryConditions(conditions) {
            // 清空現有狀態
            this.lstQuery = [];
            this.queryConditionMap.clear();
            
            if (!conditions) return;
            
            // 關鍵字
            if (conditions.keyword) {
                this.lstQuery.push(conditions.keyword);
                this.queryConditionMap.set(conditions.keyword, { type: 'keyword', value: conditions.keyword });
                this.keyword = conditions.keyword;
            }
            
            // 公司狀況
            if (conditions.companyStatus) {
                this.lstQuery.push(conditions.companyStatus);
                this.queryConditionMap.set(conditions.companyStatus, { type: 'companyStatus', value: conditions.companyStatus });
            }
            
            // 公司類別（陣列）
            if (conditions.companyType && Array.isArray(conditions.companyType)) {
                conditions.companyType.forEach(type => {
                    this.lstQuery.push(type);
                    this.queryConditionMap.set(type, { type: 'companyType', value: type });
                });
            }
            
            // 組織別（陣列）
            if (conditions.orgType && Array.isArray(conditions.orgType)) {
                conditions.orgType.forEach(type => {
                    this.lstQuery.push(type);
                    this.queryConditionMap.set(type, { type: 'orgType', value: type });
                });
            }
            
            // 布林值條件
            if (conditions.isCustomer) {
                this.lstQuery.push('既有客戶');
                this.queryConditionMap.set('既有客戶', { type: 'isCustomer', value: true });
                this.IsCustomer = true;
            }
            
            if (conditions.isInvoice) {
                this.lstQuery.push('有發票');
                this.queryConditionMap.set('有發票', { type: 'isInvoice', value: true });
                this.IsInvoice = true;
            }
            
            if (conditions.isImport) {
                this.lstQuery.push('有進口');
                this.queryConditionMap.set('有進口', { type: 'isImport', value: true });
                this.IsImport = true;
            }
            
            if (conditions.isExport) {
                this.lstQuery.push('有出口');
                this.queryConditionMap.set('有出口', { type: 'isExport', value: true });
                this.IsExport = true;
            }
            
            if (conditions.isFactory) {
                this.lstQuery.push('有工廠');
                this.queryConditionMap.set('有工廠', { type: 'isFactory', value: true });
                this.IsFactory = true;
            }
            
            // 資本額
            if (conditions.capital && conditions.capital.range) {
                this.lstQuery.push(conditions.capital.range);
                this.queryConditionMap.set(conditions.capital.range, { 
                    type: 'capital', 
                    value: conditions.capital 
                });
            }
            
            // 設立日期
            if (conditions.setupDate && conditions.setupDate.range) {
                this.lstQuery.push(conditions.setupDate.range);
                this.queryConditionMap.set(conditions.setupDate.range, { 
                    type: 'setupDate', 
                    value: conditions.setupDate 
                });
            }
            
            // 行業代碼（陣列）
            if (conditions.industryCode && Array.isArray(conditions.industryCode)) {
                conditions.industryCode.forEach(code => {
                    const displayText = this.formatIndustryCodeDisplay(code);
                    if (displayText) {
                        this.lstQuery.push(displayText);
                        this.queryConditionMap.set(displayText, { type: 'industryCode', value: code });
                    }
                });
            }
            
            // 地址
            if (conditions.location) {
                const locationText = this.formatLocationDisplay(conditions.location);
                if (locationText) {
                    this.lstQuery.push(locationText);
                    this.queryConditionMap.set(locationText, { type: 'location', value: conditions.location });
                }
            }
            
            console.log('重建後的狀態:', {
                lstQuery: this.lstQuery,
                queryConditions: this.queryConditions,
                mapping: Array.from(this.queryConditionMap.entries())
            });
        },        

        addSaveSearch() {
            this.diaglogTitle = "新增搜尋條件";
            this.dialogButton = "新增";
            this.diaglogMode = "add";
            this.addInfo = {
                ID: '',
                ConditionName: '',
                memo: ''
            };
            this.clearAllQueryConditions();  // 清空所有查詢條件
            this.showSaveSearch = true;
        },

        saveSearchOp() {
            const conditionName = (this.addInfo.ConditionName || '').trim();
            const memo = this.addInfo.memo || '';

            // 檢查是否有輸入名稱
            if (!conditionName) {
                notify({ type: 'warning', title: '警告', message: '請輸入搜尋條件名稱' });
                return;
            }

            if (conditionName.length > 100) {
                notify({ type: 'warning', title: '警告', message: '條件名稱不得超過100個字' });
                return;
            }

            if (memo.length > 100) {
                notify({ type: 'warning', title: '警告', message: '備註不得超過100個字' });
                return;
            }

            this.addInfo.ConditionName = conditionName;
            this.addInfo.memo = memo;

            // 由diaglogMode
            if( this.diaglogMode=="add") {
                let qry = {
                    name: this.ssName,
                    desc: this.ssDesc,
                    displayTags: [...this.lstQuery],           // 顯示用的標籤
                    conditions: { ...this.queryConditions },   // 結構化的查詢條件
                    mapping: Array.from(this.queryConditionMap.entries())  // 映射關係
                };
                // console.log('已儲存搜尋條件:', qry);
                // console.log('目前儲存的搜尋條件列表:', this.saveSearchList);
                // console.log('queryConditions:', this.queryConditions);

                // 呼叫API儲存到後端
                this.$api.apisc.sc_create({
                        "ConditionName": conditionName,
                    "Memo": memo,
                        "Parameters": this.queryConditions                    
                }).then((res)=>{
                    console.log('儲存搜尋條件到後端成功:', res);
                    this.getList();
                    notify({ type: 'success', title: '成功', message: `已成功儲存搜尋條件: ${conditionName}` });
                    this.showSaveSearch = false;
                }, err => {
                    handleError(err, '儲存搜尋條件到後端失敗');
                });
            };
            
            if( this.diaglogMode=="edit") {
                console.log("編輯模式下儲存搜尋條件:", {
                    ID: this.addInfo.ID,
                    ConditionName: this.addInfo.ConditionName,
                    queryConditions: this.queryConditions
                });
                // 編輯模式下的儲存邏輯
                this.$api.apisc.sc_update({
                    "ID": this.addInfo.ID,
                    "ConditionName": conditionName,
                    "Memo": memo,
                    "Parameters": this.queryConditions                    
                }).then((res)=>{
                    console.log('更新搜尋條件到後端成功:', res);
                    this.getList();
                    notify({ type: 'success', title: '成功', message: `已成功更新搜尋條件: ${conditionName}` });
                    this.showSaveSearch = false;
                }, err => {
                    handleError(err, '更新搜尋條件到後端失敗');
                });
            }
        },



        editSaveSearch(row) {
            console.log("edit", row);
            this.diaglogTitle = "編輯搜尋條件";
            this.dialogButton = "儲存";
            this.diaglogMode = "edit";
            this.addInfo = {
                ...row,
                memo: row.memo || row.Memo || ''
            };  // 深拷貝避免直接修改原始數據
            
            // 先清空所有 UI 狀態，避免殘留之前的選擇
            this.IsCustomer = false;
            this.IsInvoice = false;
            this.IsImport = false;
            this.IsExport = false;
            this.IsFactory = false;
            this.selectedIndustryCode = [];
            this.selectedAreaValue = ['全部', '全部'];
            this.selectedCity = '全部';
            this.selectedDistrict = '';
            
            // 深拷貝 queryConditions
            this.queryConditions = JSON.parse(JSON.stringify(row.Parameters || {}));
            
            // 從 queryConditions 重建 lstQuery 和映射關係
            this.rebuildFromQueryConditions(this.queryConditions);
            
            // 恢復 UI 狀態根據 queryConditions
            if (this.queryConditions) {
                // 恢復布林值條件
                this.IsCustomer = this.queryConditions.isCustomer || false;
                this.IsInvoice = this.queryConditions.isInvoice || false;
                this.IsImport = this.queryConditions.isImport || false;
                this.IsExport = this.queryConditions.isExport || false;
                this.IsFactory = this.queryConditions.isFactory || false;
                
                // 恢復行業代碼
                this.selectedIndustryCode = this.queryConditions.industryCode || [];
                
                // 恢復地區選擇
                if (this.queryConditions.location && (this.queryConditions.location.city || this.queryConditions.location.district)) {
                    const { area, city, district } = this.queryConditions.location;
                    const areaNames = ['北部', '中部', '南部', '東部'];
                    
                    if (area && areaNames.includes(area)) {
                        if (district) {
                            this.selectedAreaValue = [area, city, district];
                        } else {
                            this.selectedAreaValue = [area, city];
                        }
                    } else if (city) {
                        this.selectedAreaValue = ['全部', city];
                        if (district) {
                            this.selectedAreaValue.push(district);
                        }
                    }
                    this.selectedCity = city || '全部';
                    this.selectedDistrict = district || '';
                }
            }
            
            this.showSaveSearch = true;
            
            console.log("編輯模式初始化完成:", {
                queryConditions: this.queryConditions,
                lstQuery: this.lstQuery,
                mapping: Array.from(this.queryConditionMap.entries()),
                uiStates: {
                    selectedAreaValue: this.selectedAreaValue,
                    IsCustomer: this.IsCustomer,
                    IsInvoice: this.IsInvoice,
                    IsImport: this.IsImport,
                    IsExport: this.IsExport,
                    IsFactory: this.IsFactory
                }
            });
        },

        delSs(row) {
            this.$confirm('是否確定刪除該筆搜尋儲存？', '警告', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                // 執行刪除動作
                this.$api.apisc.sc_delete({"ID": row.ID}).then( res => {
                    this.getList();
                    notify({title: '成功', text: '刪除成功', type: 'success'});
                }).catch( err => {
                    console.error(err);
                    notify({title: '錯誤', text: err, type: 'error'});                
                });
                
                
              }).catch(() => {
                notify({title: '資訊', text: '已取消刪除', type: 'info'});                
              });
            // console.log("del",row);
        },
        
        dashFormat: function(value) {
            
            if( value===null || value?.length!=8) 
                return "";
            else  {                
                return value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6);
            }
        },

        async doSearch() {
            this.listQuery.Page_Num = 1;
            await this.getList();
        },

        async getList() {
            this.$store.dispatch("loadingHandler", true);
            let qry = {
                Page_Num: this.listQuery.Page_Num,
                Page_Size: this.listQuery.Page_Size,                
            };

            if( this.keyword.trim()!="" ) {
                qry.ConditionName = this.keyword.trim();
            }   
            console.log("getList qry", qry);
            // 取得列表資料
            this.$api.apisc.sc_search(qry).then( res => {
                this.tableData = res.data;
                this.totalLists = res.total;                
                console.log("getList",res.data);

                if( this.tableData.length>0 ) {
                    this.tableData.forEach( item => {

                        const queryTags = item.Parameters ? Object.entries(item.Parameters).map(([key, value]) => {
                            // 根據 key 轉換成顯示標籤
                            switch(key) {
                                case 'keyword':
                                    return value || null;
                                case 'companyStatus':
                                    return value || null;
                                case 'companyType':
                                    return value || null; // 假設 value 是陣列
                                case 'orgType':
                                    return value || null; // 假設 value 是陣列
                                case 'isCustomer':
                                    return value ? '既有客戶' : null;
                                case 'isInvoice':
                                    return value ? '開立發票' : null;
                                case 'isImport':
                                    return value ? '進口' : null;
                                case 'isExport':
                                    return value ? '出口' : null;
                                case 'isFactory':
                                    return value ? '工廠' : null;
                                case 'capital':
                                    return (value.start && value.end) ? `${value.start}萬~${value.end}萬` : null;
                                case 'setupDate':
                                    return value.range || null;
                                case 'industryCode':
                                    return this.formatIndustryCodeDisplay(value);
                                case 'location':
                                    return this.formatLocationDisplay(value);
                                default:
                                    return null;
                            }
                        }).flat().filter(x => x !== null) : [];                    
                        // item.ssWord = queryTags.join(" / ");                
                        item.ssWord = queryTags;
                    }); 
                };

            }).catch( err => {
                console.error(err);
                notify({title: '錯誤', text: err, type: 'error'});                
            });

            this.$store.dispatch("loadingHandler", false);
        },

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },

        handleSelectionChange(val) {
            console.log("checked",val);
            this.selectData = val;
        },  
        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },                                   
        // 更新公司狀況處理
        comStatusChangeHandler(value) {
            console.log('公司狀況變更:', value);
            
            // 先移除舊的公司狀況標籤
            const statusTags = ['全部', '營業中', '非營業中'];
            statusTags.forEach(tag => {
                if (this.lstQuery.includes(tag)) {
                    this.removeQueryCondition(tag);
                }
            });
            
            // 添加新的條件
            if (value && value !== '全部') {
                this.addQueryCondition('companyStatus', value, value);
            }
            
            this.selectedComStatus = value;
        },
        
        // 更新公司類別處理
        comTypeChangeHandler(value) {
            console.log('公司類別變更:', value);
            
            if (value === '全部') {
                // 移除所有公司類別標籤
                this.ComTypeList.forEach(item => {
                    if (this.lstQuery.includes(item.comType)) {
                        this.removeQueryCondition(item.comType);
                    }
                });
            } else {
                // 先移除 "全部" 標籤
                if (this.lstQuery.includes('全部')) {
                    this.removeQueryCondition('全部');
                }
                
                // 添加新的公司類別
                this.addQueryCondition('companyType', value, value);
            }
            
            this.selectedComType = value;
        },
        
        // 更新組織別處理
        orgTypeChangeHandler(value) {
            console.log('組織別變更:', value);
            
            if (value === '全部') {
                // 移除所有組織別標籤
                this.OrgTypeList.forEach(item => {
                    if (this.lstQuery.includes(item.comType)) {
                        this.removeQueryCondition(item.comType);
                    }
                });
            } else {
                // 先移除 "全部" 標籤
                if (this.lstQuery.includes('全部')) {
                    this.removeQueryCondition('全部');
                }
                
                // 添加新的組織別
                this.addQueryCondition('orgType', value, value);
            }
            
            this.selectedOrgType = value;
        },
        
        // 更新其他條件處理
        otherChangeHandler(value) {
            const conditionMap = {
                '既有客戶': { type: 'isCustomer', checked: this.IsCustomer },
                '有發票': { type: 'isInvoice', checked: this.IsInvoice },
                '有進口': { type: 'isImport', checked: this.IsImport },
                '有出口': { type: 'isExport', checked: this.IsExport },
                '有工廠': { type: 'isFactory', checked: this.IsFactory }
            };
            
            const condition = conditionMap[value];
            if (condition) {
                if (condition.checked) {
                    this.addQueryCondition(condition.type, true, value);
                } else {
                    this.removeQueryCondition(value);
                }
            }
        },        

        // 更新資本額處理
        radClick(val) {
            console.log(val);

            // 如果選擇自訂區間，開啟對話框
            if (val === 'custom') {
                this.showCustomCapital = true;
                return;
            }

            const capInfo = this.capList.find(x => x.value === val);
            const displayText = capInfo.start && capInfo.end ? `${capInfo.start}萬~${capInfo.end}萬` : capInfo.cap;
            
            // 先移除舊的資本額標籤
            this.capList.forEach(cap => {
                if (this.lstQuery.includes(cap.cap)) {
                    this.removeQueryCondition(cap.cap);
                }
            });

            // 移除結構化條件中舊的資本額標籤（含自訂區間）
            if (this.queryConditions.capital && this.queryConditions.capital.range) {
                this.removeQueryCondition(this.queryConditions.capital.range);
            }
            
            // 添加新的資本額條件
            this.addQueryCondition('capital', {
                start: capInfo.start,
                end: capInfo.end,
                range: displayText
            }, displayText);
            
            this.radCap = val;
        },

        // 確認自訂資本額區間
        confirmCustomCapital() {
            const start = parseFloat(this.customCapital.start);
            const end = parseFloat(this.customCapital.end);

            // 驗證輸入
            if (!start || !end) {
                notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束金額' });
                return;
            }

            if (start >= end) {
                notify({ type: 'warning', title: '警告', message: '起始金額必須小於結束金額' });
                return;
            }

            // 移除舊的資本額標籤（包含預設與自訂）
            this.capList.forEach(cap => {
                if (this.lstQuery.includes(cap.cap)) {
                    this.removeQueryCondition(cap.cap);
                }
            });

            if (this.queryConditions.capital && this.queryConditions.capital.range) {
                this.removeQueryCondition(this.queryConditions.capital.range);
            }

            // 建立顯示文字
            const displayText = `${start}萬~${end}萬`;

            // 添加新的資本額條件
            this.addQueryCondition('capital', {
                start: start,
                end: end,
                range: displayText
            }, displayText);

            // 清空輸入並關閉對話框
            this.customCapital.start = '';
            this.customCapital.end = '';
            this.showCustomCapital = false;

            notify({ type: 'success', title: '成功', message: `已設定資本額區間：${displayText}` });
        },
        
        // 更新設立日期處理
        yearClick(val) {
            // 如果選擇自訂區間，開啟對話框
            if (val === 'custom') {
                this.showCustomYear = true;
                return;
            }

            const yearInfo = this.yearList.find(x => x.value === val);
            const displayText = yearInfo.cap;
            
            // 計算實際的日期範圍
            const currentYear = new Date().getFullYear();
            const startYear = currentYear - yearInfo.end;
            const endYear = currentYear - yearInfo.start;
            
            const startDate = `${startYear}-01-01`;
            const endDate = `${endYear}-12-31`;
            
            console.log('設立日期計算:', {
                currentYear,
                yearInfo,
                startYear,
                endYear,
                startDate,
                endDate
            });
            
            // 先移除舊的設立日期標籤
            this.yearList.forEach(year => {
                if (this.lstQuery.includes(year.cap)) {
                    this.removeQueryCondition(year.cap);
                }
            });

            if (this.queryConditions.setupDate && this.queryConditions.setupDate.rangeValue == "custom") {
                this.removeQueryCondition(this.queryConditions.setupDate.range);
            }
            
            // 添加新的設立日期條件
            this.addQueryCondition('setupDate', {
                range: displayText,
                start: startDate,
                end: endDate,
                rangeValue: val
            }, displayText);
            
            this.yearCap = val;
        },

        // 確認自訂設立日期區間
        confirmCustomYear() {
            const start = parseFloat(this.customYear.start);
            const end = parseFloat(this.customYear.end);

            // 驗證輸入
            if (!start || !end) {
                notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束年限' });
                return;
            }

            if (start >= end) {
                notify({ type: 'warning', title: '警告', message: '起始年限必須小於結束年限' });
                return;
            }

            // 移除舊的設立日期標籤（包含預設與自訂）
            this.yearList.forEach(year => {
                if (this.lstQuery.includes(year.cap)) {
                    this.removeQueryCondition(year.cap);
                }
            });

            if (this.queryConditions.setupDate && this.queryConditions.setupDate.range) {
                this.removeQueryCondition(this.queryConditions.setupDate.range);
            }

            // 建立顯示文字
            const displayText = `${start}年~${end}年`;

            // 計算實際的日期範圍
            const currentYear = new Date().getFullYear();
            const startYear = currentYear - end;
            const endYear = currentYear - start;
            const startDate = `${startYear}-01-01`;
            const endDate = `${endYear}-12-31`;

            // 添加新的設立日期條件
            this.addQueryCondition('setupDate', {
                range: displayText,
                start: startDate,
                end: endDate,
                rangeValue: 'custom'
            }, displayText);

            // 清空輸入並關閉對話框
            this.customYear.start = '';
            this.customYear.end = '';
            this.showCustomYear = false;

            notify({ type: 'success', title: '成功', message: `已設定設立日期區間：${displayText}` });
        },        

        // 更新行業代碼處理
        handleIndustryCodeChange(value, selectedItems) {
            if (!value || value.length === 0) {
                return;
            }
            
            // 確保 selectedItems 存在且為陣列
            if (!selectedItems || !Array.isArray(selectedItems) || selectedItems.length === 0) {
                console.warn('selectedItems 為空或無效');
                return;
            }
            
            selectedItems.forEach(item => {
                if (item && item.label) {
                    this.addQueryCondition('industryCode', value[3], item.label);
                }
            });
            
            this.selectedIndustryCode = [];
        },

        // 更新標籤關閉處理
        handleClose(tag) {
            this.removeQueryCondition(tag);
        },        
                

    },    

    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        await this.loadIndustryCodeNameMap();
        await this.getList();
        // await this.getBranchDist();
        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>
//  * {
//      outline: 1px solid red;
//  }


#hqAssignBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;


  .dialogBox {
    display: flex;
    flex-direction: column;;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row1 {
        display: flex;
        flex-direction: row;    
        align-items: center;
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;                
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }

        label {
            margin-right: 10px;
            margin-top:10px;
            white-space: nowrap;
            font-weight: bold;
            font-size:medium;
        }        
        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top:5px; 
            margin-bottom: 5px;
            margin-right: 15px;
            
            label {                    
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;                
            }
            .el-checkbox {
                white-space: nowrap;
                top: -0.5rem;
                label {
                    white-space: nowrap;                        
                }
            }            
        }        
    }
    .row3 {
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;  
        width: 100%;
        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
      }
    }      
  }


  .searchWrap   {
    display: flex;
    flex-direction: row;    
    justify-content: space-between;
    padding: 0px 5%;
    .row {
        display: flex;
        flex-direction: row;    
        justify-content: center;

        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin-top:20px; 
            margin-bottom: 20px;
        }
        

    }
    .row3 {
      width:30%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: flex-end;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
      }
    }     
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    margin-top: 20px;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }

   .titleLabel {
        font-size: medium;
        font-weight: bold;
        margin-left: 10px;
        min-width: 120px;
        width: 90px;
        flex-shrink: 0;
   }

   .memoRow {
       align-items: flex-start;
       .titleLabel {
           margin-top: 12px;
       }
   }
}
</style>